import React from 'react';
import { Tab } from 'react-tabs';

import { T } from '../../../../../common/locale/translate';
import { offersListTabsIds } from '../../../common/objects/consts';
import { insertIf } from '../../../services/services';

const tabsData = [
  {
    id: offersListTabsIds.SEO_OFFERS_LIST,
    iconClass: 'fa fa-list',
    text: 'seo_offers_list'
  },
  {
    id: offersListTabsIds.SEO_REGION_INFORMATION,
    iconClass: 'fa fa-globe',
    text: 'seo_region_information'
  },
  {
    id: offersListTabsIds.SEO_PRACTICAL_INFORMATION,
    iconClass: 'fa fa-list',
    text: 'seo_practical_information'
  },
  {
    id: offersListTabsIds.SEO_MAP,
    iconClass: 'fa fa-map-marker',
    text: 'seo_map'
  }
];

const createTab = ({ id, text, iconClass }, onClick, key) => (
  <Tab onClick={() => onClick(id)} key={key}>
    <a id={id} href="javascript:void(0)" title={T(text)}>
      <span className={iconClass} />
      {T(text)}
    </a>
  </Tab>
);

export const createSeoTabs = (
  onTabClick,
  isRegionInfoTabVisible,
  isUsefulInfoTabVisible,
  isMapTabVisible
) => [
  createTab(tabsData[0], onTabClick, 'seo-tab-0'),
  ...insertIf(
    isRegionInfoTabVisible,
    createTab(tabsData[1], onTabClick, 'seo-tab-1')
  ),
  ...insertIf(
    isUsefulInfoTabVisible,
    createTab(tabsData[2], onTabClick, 'seo-tab-2')
  ),
  ...insertIf(isMapTabVisible, createTab(tabsData[3], onTabClick, 'seo-tab-3'))
];



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/SeoTabs.jsx